import { ReactElement, ReactNode } from 'react';
import usePlan from '../hooks/usePlan';
import Procard from './Procard';

type PlanGateProps = {
  requiredPlan: string;
  children: ReactNode;
};

/**
 * PlanGate wraps content that requires a minimum plan.
 * Shows a centered Procard upgrade prompt when the user's plan is insufficient.
 * @param root0 - Component props.
 * @param root0.requiredPlan - The minimum plan name required to view the content.
 * @param root0.children - Content to render when the user has access.
 * @returns - The children if access is granted, otherwise an upgrade overlay.
 */
export default function PlanGate({ requiredPlan, children }: PlanGateProps): ReactElement {
  const { hasAccess } = usePlan();

  if (hasAccess(requiredPlan)) {
    return children as ReactElement;
  }

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 py-16">
      <Procard />
      <p className="text-gray-400 text-sm font-medium">
        Upgrade to{' '}
        <span className="text-white font-semibold">{requiredPlan}</span> plan or above to unlock
        this feature.
      </p>
    </div>
  );
}
